import { createFileRoute } from "@tanstack/react-router";

import { HelpdeskTopicsPage } from "@/features/helpdesk-topics/pages/helpdesk-topics-page";

export const Route = createFileRoute("/_authenticated/admin/helpdesk-topics/")({
	component: HelpdeskTopicsPage,
});
